import { FC } from 'react'
import { TailSpin } from 'react-loader-spinner'

interface LoaderProps {
  color?: string
  size?: number
}

const Loader: FC<LoaderProps> = (props) => {
  const { color = '#4fa94d', size = 80 } = props
  return (
    <TailSpin
      height={size}
      width={size}
      color={color}
      ariaLabel="tail-spin-loading"
      radius="1"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    />
  )
}

export default Loader
